import { getDomain } from "@/utilities/url";
import db64 from "db64";

export enum IndexedDbKey {
  AiLastCategoryId = "ai-vision-last-category-id",
  PendingAfterAuthRedirect = "pendingAfterAuthRedirect",
  UserToken = "userToken",
  DoNotShowOldMarketplaceItemsDialog = "doNotShowOldMarketplaceItemsDialog",
}

const DbName = getDomain();
const StoreName = "default";

let db: ReturnType<typeof db64.use>;

async function getDb() {
  if (!db) {
    await db64.create(DbName, [StoreName]);
    db = db64.use(DbName, StoreName);
  }

  return db;
}

/**
 * Only keys from IndexedDbKey enum are allowed to prevent
 * unwanted overriding when accidentally using same indexedDb key
 * for different purpose.
 **/
export const IndexedDb = {
  get: async (entryName: IndexedDbKey) => {
    const db = await getDb();
    const found = await db.getEntries(entryName);

    if (found[entryName]) {
      return found[entryName];
    } else {
      return undefined;
    }
  },

  set: async (entryName: IndexedDbKey, entryValue: unknown) => {
    const db = await getDb();
    return db.set(entryName, entryValue);
  },

  delete: async (entryName: IndexedDbKey) => {
    const db = await getDb();
    return db.delete(entryName);
  },
};
